
import { AccountStatus } from '@/types/account';
import { RouteChangeTransitionType } from '@/types/global';
import { initBeaconSDK, reportPV } from '@/apis/report';
import Vue from 'vue';
import { mapActions, mapState, mapMutations } from 'vuex';
import getAegis from '@/utils/aegis';

const aegis = getAegis();

export default Vue.extend({
  name: 'LayoutBase',
  data() {
    return {
      isAccountDataLoaded: false,
      globalTransitionName: 'fade-slide',
    };
  },
  computed: {
    ...mapState('route', {
      isRouteBack: (state: any) => state?.routeChangeTransitionType === RouteChangeTransitionType.Reverse,
    }),
  },
  watch: {
    $route() {
      if (this.isRouteBack) {
        this.globalTransitionName = 'fade-slide-reverse';
      } else {
        this.globalTransitionName = 'fade-slide';
      }
      this.updateRouteTransitionType(RouteChangeTransitionType.Normal);
    },
  },
  async created() {
    // 在进入页面时需要判断用户状态
    try {
      this.updateInitialGlobalData();
      const { status } = await this.updateAccountInfo();
      initBeaconSDK();
      reportPV();
      this.isAccountDataLoaded = true;
      if (status === AccountStatus.Accepted) {
        // 仅在账户状态为已接受时，才更新用户信息，否则将返回404
        this.updateUserInfo();
      }
    } catch (error: any) {
      try {
        aegis?.report({
          msg: '进入ErrorPage',
          ext1: 'layout base update accountinfo error',
          ext2: JSON.stringify(error) || error?.toString() || error,
        });
      } catch {}
      this.$router.push({
        name: 'ErrorPage',
      });
      console.log('Error happened in layout base.');
    }
    (window as any)._goToVBridgeDemo = () => {
      this.$router.push({
        name: 'BridgeDemo',
      });
    };
  },
  methods: {
    ...mapActions('account', ['updateAccountInfo', 'updateUserInfo']),
    ...mapActions(['updateInitialGlobalData']),
    ...mapMutations('route', ['updateRouteTransitionType']),
  },
});
